import { Skeleton, SkeletonStatCard } from './Skeleton';

/**
 * Loading skeleton for the Dashboard page
 */
export function DashboardPageSkeleton() {
  return (
    <>
      {/* Hero Balance Card Skeleton */}
      <div className="bg-gradient-to-br from-[#1B365D] to-[#2d4a7c] rounded-lg p-8 mb-6">
        <div className="text-white">
          <Skeleton height={16} width={140} className="mb-4 bg-white/20" />
          <Skeleton height={48} width={200} className="mb-2 bg-white/30" />
          <Skeleton height={14} width={120} className="bg-white/20" />
        </div>
      </div>

      {/* Stats Grid Skeleton */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
        <SkeletonStatCard />
        <SkeletonStatCard />
      </div>

      {/* Recent Expenses List Skeleton */}
      <div className="bg-white rounded-lg border border-[#E2E8F0] overflow-hidden mb-6">
        <div className="px-6 py-4 border-b border-[#E2E8F0] flex items-center justify-between">
          <Skeleton height={20} width={150} />
          <Skeleton height={32} width={120} />
        </div>
        <div className="divide-y divide-[#E2E8F0]">
          {Array.from({ length: 5 }).map((_, i) => (
            <div key={i} className="px-6 py-4">
              <div className="flex items-center justify-between">
                <div className="flex-1">
                  <Skeleton height={16} width="40%" className="mb-2" />
                  <Skeleton height={14} width="60%" />
                </div>
                <div className="text-right">
                  <Skeleton height={18} width={80} className="mb-1 ml-auto" />
                  <Skeleton height={12} width={60} className="ml-auto" />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Quick Tip Banner Skeleton */}
      <div className="bg-gradient-to-r from-[#FEF9C3] to-[#FEF08A] rounded-lg border border-[#FDE047] p-6">
        <div className="flex items-start gap-4">
          <Skeleton variant="circular" width={40} height={40} />
          <div className="flex-1">
            <Skeleton height={18} width="30%" className="mb-2" />
            <Skeleton height={14} width="80%" className="mb-1" />
            <Skeleton height={14} width="70%" />
          </div>
        </div>
      </div>
    </>
  );
}
